<template>
  <div class="sec">
    <van-nav-bar title="安全设置" left-arrow fixed @click-left="$router.back()" />
    <div style="height: 46px"></div>
    <div class="group">
      <div class="item" @click="$router.push('/password?type=1')">
        <span>修改登录密码</span>
        <van-icon name="arrow" />
      </div>
      <div class="item" @click="$router.push('/password?type=2')">
        <span>修改支付密码</span>
        <van-icon name="arrow" />
      </div>
    </div>
  </div>
</template>
<script>
export default { name: 'security' };
</script>
<style scoped>
.sec { min-height: 100vh; background: #f3f3f6; }
.group { margin-top: 12px; background: #fff; }
.item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 52px;
  padding: 0 16px;
  border-bottom: 1px solid #eee;
  font-size: 15px;
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/components/security.vue